import { useEffect } from 'react';
import { useLoggerWithContext } from '@/services/logger/loggerContext';

export function useCspViolationReporter(): void {
  const logger = useLoggerWithContext();

  useEffect(() => {
    const handler = (event: SecurityPolicyViolationEvent) => {
      logger.warn('csp-violation', {
        blockedURI: event.blockedURI,
        violatedDirective: event.violatedDirective,
        effectiveDirective: event.effectiveDirective,
        disposition: event.disposition,
        sourceFile: event.sourceFile,
        lineNumber: event.lineNumber,
        columnNumber: event.columnNumber,
        documentURI: event.documentURI,
      });
    };

    window.addEventListener('securitypolicyviolation', handler);
    return () => window.removeEventListener('securitypolicyviolation', handler);
  }, [logger]);
}
